// Builds the regex used to decide whether a link may be embedded in an iframe.
//
// ALLOW_IFRAME_DOMAINS entries are a mix of bare domains (`c8health.com`) and full base
// URLs with scheme/port (`http://localhost:4500/` in dev, `https://assets.app…/` in prod).
// Each is reduced to its host[:port] and matched host-anchored, so:
//   - a full-URL entry still matches (a naive substring join can't — you can't have a second
//     `http://` mid-URL — which previously broke local-dev localhost previews),
//   - an entry can't pass as an unescaped substring buried in a query string
//     (`https://evil.com/?u=https://assets.c8health.com/` must NOT match),
//   - a bare host like `localhost:4500` matches exactly, and `c8health.com` also covers its
//     subdomains (`assets.c8health.com`).

const escapeRegExp = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/** Reduce an allow-list entry (bare domain or full URL) to its host[:port]. */
export const toIframeHost = entry => {
  try {
    return new URL(entry).host;
  } catch {
    return String(entry).replace(/^\/+|\/+$/g, '');
  }
};

/**
 * @param {string[]} domains - ALLOW_IFRAME_DOMAINS entries
 * @returns {RegExp} matches a URL whose host is (a subdomain of) an allow-listed host
 */
export const buildIframeAllowRegex = (domains = []) => {
  const hosts = domains.map(toIframeHost).filter(Boolean);
  return new RegExp(
    `^https?://([^/?#]+\\.)?(${hosts.map(escapeRegExp).join('|')})([/:?#]|$)`,
    'i',
  );
};
